import moment from 'moment-timezone';

export const validatePreAuthorization = (field, value, data) => {
  let errMsg = '';
  switch (field) {
    case 'patientCoverage':
      if (!value) {
        errMsg = 'You should select patient coverage';
      }
      break;
    case 'authCode':
      if (!value) {
        errMsg = 'Pre auth code should not be empty';
      }
      break;
    case 'startDate':
      if (value === undefined) {
        errMsg = 'Invalid date format';
      } else if (!value) {
        errMsg = 'Date should not be empty';
      } else if (value && moment(value).isAfter(data.endDate)) {
        errMsg = 'Start date should be before end date';
      }
      break;
    case 'endDate':
      if (value === undefined) {
        errMsg = 'Invalid date format';
      } else if (value && moment(value).isBefore(data.startDate)) {
        errMsg = 'End date should be after start date';
      }
      break;
    case 'status':
      if (!value) {
        errMsg = 'Status should not be empty';
      }
      break;
    case 'serviceType':
      if (!value) {
        errMsg = 'Service type should not be empty';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
